import i18n from 'simple-react-i18n'
import Input from '../../../../components/forms/Input'
import { getDate, getDateWithHour, getHour } from '../../../../utils/DateUtil'
import { onChangeDate, onChangeHour } from '../../../../utils/FormUtils'
import React, { useState } from 'react'
import Button from '../../../../components/forms/Button'
import HydrometryAction from '../../../actions/HydrometryAction'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import ConfirmModal from '../../../../components/modal/ConfirmModal'
import NumberField from '../../../../components/forms/NumberField'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import { isNull } from 'lodash'
import { measureHydroType } from '../../../shapes/HydroShapes'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

const CorrectionHydroToolPanel = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isChange,
    setIsChange,
    createTechnicalEvent,
    measuresSelectedByFilters,
    setSerieLinePrevious,
    isPreview,
    setIsPreview,
    valueCorrection,
    setValueCorrection,
    measuresData,
}) => {
    const [modalOpen, setModalOpen] = useState(false)

    const dispatch = useDispatch()

    const len = measuresSelectedByFilters?.length
    const diff = valueCorrection - measuresSelectedByFilters[len-1]?.value
    const lastDate = measuresSelectedByFilters[len-1]?.date
    const timeDiff = lastDate - measuresSelectedByFilters[0]?.date

    const onValidate = () => {
        if (isNull(startDate) || isNull(endDate)) {
            dispatch(ToastrAction.warning(i18n.datesNoSelected))
        }
        setIsPreview(true)
        const getDiff = (measure) => diff * (1 - ((lastDate - measure) / timeDiff))

        const dataHydro = measuresData[0].measuresSelectedByFilters.map(d => ([ d.date, d.value ]))

        const findIndexStartDate = dataHydro.findIndex(m => m[0]===startDate)-1
        const measureBeforeStartDate = dataHydro[findIndexStartDate]

        const findIndexEndDate = dataHydro.findIndex(m => m[0]===endDate)+1
        const measureAfterStartDate = dataHydro[findIndexEndDate]

        const measuresPrevious = measuresSelectedByFilters.map(m => ({
            date: m.date,
            value: m.value + getDiff(m.date),
        }),
        )

        const allMeasuresPreview = [
            ...(measureBeforeStartDate ? [{
                date: measureBeforeStartDate[0],
                value: measureBeforeStartDate[1],
            }] : []),
            ...measuresPrevious,
            ...(measureAfterStartDate ? [{
                date: measureAfterStartDate[0],
                value: measureAfterStartDate[1],
            }] : []),
        ]
        setSerieLinePrevious(allMeasuresPreview)
    }

    const onCancel = () => {
        setIsPreview(false)
        setSerieLinePrevious(measuresSelectedByFilters)
    }

    const onSave = () => {
        setIsPreview(false)
        setModalOpen(true)

        const getDiff = (measure) => diff * (1 - ((lastDate - measure) / timeDiff))

        const measuresChanges = measuresSelectedByFilters.map(m => ({
            ...m,
            value: m.value + getDiff(m.date),
            updated: true,
        }),
        )

        return (
            <ConfirmModal
                isOpen={modalOpen}
                title={i18n.driftingCorrection}
                onValidate={
                    dispatch(HydrometryAction.updateMeasures(measuresChanges))
                        .then(() => setIsChange(!isChange))
                        .then(() => createTechnicalEvent({ mode: 'correction' }))

                }
                onClose={() => setModalOpen(false)}
            />
        )
    }

    const resetDates = () => {
        setStartDate(null)
        setEndDate(null)
    }

    return (
        <div>
            <Card>
                <CardTitle title={i18n.driftingCorrection} />
                <CardContent>
                    <Grid container sx={{ padding: '10px 0.75rem 0 0.75rem' }} columnSpacing={2}>
                        <Grid container size={12} sx={{ pb: '10px', alignItems: 'center' }} columnSpacing={1}>
                            <Button
                                tooltip={ i18n.resetDates }
                                icon='loop'
                                className='validToolBtn'
                                onClick={ () => resetDates() }
                                disabled={ isPreview }
                            />
                            <Typography sx={{ fontSize: '1.1rem' }}>{ i18n.resetDates }</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Input
                                title={ i18n.startDate }
                                id='startDate'
                                value={ getDate(startDate) }
                                onChange={ v => {
                                    onChangeDate(v, v2 => {
                                        return setStartDate(getDateWithHour(v2, startDate).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Input
                                title={ i18n.startHour }
                                value={ getHour(startDate) }
                                onChange={ v => {
                                    onChangeHour(v, v2 => {
                                        return setStartDate(getDateWithHour(startDate, v2).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Input
                                title={ i18n.endDate }
                                id='endDate'
                                value={ getDate(endDate) }
                                onChange={ v => {
                                    onChangeDate(v, v2 => {
                                        return setEndDate(getDateWithHour(v2, endDate).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Input
                                title={ i18n.endHour }
                                id='endDateHour'
                                value={ getHour(endDate) }
                                onChange={ v => {
                                    onChangeHour(v, v2 => {
                                        return setEndDate(getDateWithHour(endDate, v2).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid>
                        <Grid size={12}>
                            <NumberField
                                title={ i18n.value }
                                value={ valueCorrection }
                                onChange={ v => setValueCorrection(v) }
                                disabled={ isPreview }
                                floatValue
                            />
                        </Grid>
                        <Grid container size={12} sx={{ pt: '10px', textAlign: 'center', justifyContent: 'center' }}>
                            <Button
                                tooltip={ i18n.apply }
                                onClick={ onValidate }
                                icon='border_color'
                                className='btn-floating btn-large'
                                disabled={ isPreview }
                            />
                            <Button
                                tooltip={ i18n.cancel }
                                onClick={ onCancel }
                                icon='cancel'
                                className='red btn-floating btn-large'
                                disabled={ !isPreview }
                            />
                            <Button
                                tooltip={ i18n.register }
                                onClick={ onSave }
                                icon='save'
                                disabled={ !isPreview }
                                className={ `btn-floating btn-large ${isPreview ? 'pulse' : ''}` }
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>

    )
}


CorrectionHydroToolPanel.propTypes = {
    startDate: PropTypes.number,
    setStartDate: PropTypes.func,
    endDate: PropTypes.number,
    setEndDate: PropTypes.func,
    isChange: PropTypes.bool,
    setIsChange: PropTypes.func,
    isPreview: PropTypes.bool,
    setIsPreview: PropTypes.func,
    createTechnicalEvent: PropTypes.func,
    measuresSelectedByFilters: PropTypes.arrayOf(measureHydroType),
    setSerieLinePrevious: PropTypes.func,
    measuresData: PropTypes.arrayOf(measureHydroType),
    valueCorrection: PropTypes.number,
    setValueCorrection: PropTypes.func,
}

export default CorrectionHydroToolPanel

